import { atom } from 'jotai';
import { TreeNode } from 'Components/Primitives';
import { atomFamily } from 'jotai/utils';

export const UsersTreeNodesAtom = atomFamily(
  (param: { key: string; value?: TreeNode[] | null }) => atom<TreeNode[] | null>(param.value ?? null),
  (x, y) => x.key === y.key
);
